/* 
These functions make sure WordPress 
and JBST play nice together.
*/

jQuery(document).ready(function($) {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    //jQuery('.accordion p:empty, .orbit p:empty').remove();

    $('#locationSearchSubmit').on('click', function(e) {
        e.preventDefault();
        console.log($.param({location: $('#locationSearchValue').val()}));
        // findNearbyClinic();
        window.location.href = `https://focus-md.com/adhd-clinic-locations?${$.param({ location: $('#locationSearchValue').val() })}`;
    });
    
		
	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').addClass('embed-responsive-item').wrap("<div class='embed-responsive embed-responsive-16by9'/>");
     
    // offcanvas menu
    $('[data-toggle="offcanvas"]').click(function () {
      $('.row-offcanvas').toggleClass('active');
    });

    // Fixes broken Bootstrap mobile toggler
    $("#bs-example-navbar-collapse-1").removeClass('collapse');

    // Find Nearby Clinics Scripts
    const locationSubmitBtn = $("#sidebar__search-submit");

    locationSubmitBtn.on('click', function(e) {
        e.preventDefault();
        findNearbyClinic($("#sidebar__search-field").val(), 'sidebar');
    });
      
    function checkForLocationParam() {
        var field = "location";
        var url = window.location.href;
        if (url.indexOf("?" + field + "=") != -1) return true;
        else if (url.indexOf("&" + field + "=") != -1) return true;
        return false;
    }
    
    function getLocationParam() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }
    
    if (checkForLocationParam) {
        let param = getLocationParam();
        if(param.location) {
            console.log(decodeURIComponent(param.location));
            findNearbyClinic(param.location, 'archive');
        }
    }

    function extractZip(str) {
        //the regular expression below is for 5 digit US ZIP code, 5 digit US ZIP code + 4, 
        //and 6 digit alphanumeric Canadian Postal Code
        var re = /\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d/
        var input = str;
        var match = re.exec(input)
        if (match) {
            return match
        } else {
            console.warn("zip code not found")
        }
    }
            
    function findNearbyClinic(userLocation, pageLocation) {
        let sortedClinics = [];
        $.get("https://focus-md.com/wp-json/focus-md/v1/clinics")
        .then((response) => {
            let fetchedClinics = response;
            let zipCodes = fetchedClinics.map(clinic => clinic.zip);
            
            var service = new google.maps.DistanceMatrixService();
            service.getDistanceMatrix(
                {
                    origins: [userLocation],
                    destinations: zipCodes,
                    travelMode: 'DRIVING',
                    unitSystem: google.maps.UnitSystem.IMPERIAL,
                }, 
                callback);
                
            function callback(response, status) {
                console.log(response);
                let distances = response.rows[0].elements;
                let originAddress = response.originAddresses[0]
                if (originAddress !== "") {
                    fetchedClinics.forEach((clinic, index) => {
                        clinic.distance_text = distances[index].distance.text;
                        clinic.distance_value = distances[index].distance.value;
                        clinic.travel_duration = distances[index].duration.text;
                    });
                    sortedClinics = fetchedClinics.sort(function (a, b) {
                        return a.distance_value - b.distance_value;
                    });
                }
                else {
                    console.warn("Google did not find a location associated with that search input.");
                }
                
                if (pageLocation == 'archive') {
                    $("#content").html("");
                    if (originAddress !== "") {
                        sortedClinics.forEach((clinic, index) => {
                            $("#content").append(`
                            <ul class="clinic-list">
                            <li><a href="${clinic.permalink}" class="clinic-list__clinic-name">${clinic.name}</a></li>
                            <li>${clinic.notes}</li>
                            <li>${clinic.address}, ${clinic.address2 ? clinic.address2 : ""}</li>
                            <li>${clinic.city}, ${clinic.state}</li>
                            <li><strong>~${clinic.distance_text} from you</strong></li>
                            <li>Phone: ${clinic.phone}</li>
                            <li>Hours: ${clinic.hours}</li>
                            <li>Microsite: <a href="${clinic.microsite_url}">${clinic.microsite_title}</a></li>
                            </ul>
                            `);
                        });
                    }
                    else {
                        $("#content").append(`
                            <h5 style="color: #675F4B; margin-top: 2rem;">Sorry, but we could not find your location. Adding more details to the search may help.</h5>
                        `);
                    }
                }
                else if (pageLocation == 'sidebar') {
                    $(".locations-target").html('');
                    let userZip = response.originAddresses[0];
                    console.log(userZip);
                    if (originAddress !== "") {
                        $(".user-zip").text(extractZip(userZip));
                        // $(".user-zip").text(userZip.slice((userZip.length - 10), (userZip.length - 5)));
                        for (let i = 0; i < 3; i++) {
                            $(".locations-target").append(`
                            <ul class="sidebar__address">
                            <li><strong><a href="${sortedClinics[i].permalink}">${sortedClinics[i].name}</a></strong></li>
                            <li>${sortedClinics[i].address}</li>
                            <li class="line-2">${sortedClinics[i].city}, ${sortedClinics[i].state}</li>
                            <li>Call for appointments: ${sortedClinics[i].phone}</li>
                            <li><a href="${sortedClinics[i].microsite_url}">View Website</a></li>
                            </ul>
                            `);
                        }
                    }
                    else {
                        $(".locations-target").append(`
                            <h5 style="color: #675F4B; margin-top: 2rem;">Sorry, but we could not find your location. Adding more details to the search may help.</h5>
                        `);
                    }
                }
            }
        });
    }
});
